import VehiclesError from './VehiclesError.js'

export class NotFoundCompetitorsVehiclesError extends VehiclesError {}
